export default __webpack_public_path__ + "static/chen2018-6bb0397b7a9dab43ef6d5826fd6c25cf.jpg";